// extracted by mini-css-extract-plugin
export var quillEditor = "_hy-1";
export var variable = "_hy-0";